module.exports = __webpack_public_path__ + "img/PHDC-rental-repair-logo-x-450.0ce0966e.jpg";